import storeJs from 'store';
import { push } from 'react-router-redux';
import { SessionApi } from '../../../api';
import { store } from '../../../store';

export const logout = (dispatch = store.dispatch) => {
  const { actions } = SessionApi;
  storeJs.remove('jwt');
  dispatch(actions.user.reset());
  dispatch(actions.auth.reset());
  dispatch(push('/login'));
};

export const redirect = (path = '/') => {
  store.dispatch(push(path));
};

export const logoutAll = (dispatch = store.dispatch) => {
  dispatch(SessionApi.actions.logout());
};
